import React from 'react';
import { Col, Row } from 'antd';
import clsx from 'clsx';
import Dropdown from 'shared/components/Dropdown';
import LoaderAnimation from 'shared/components/LoaderAnimation';
import PieChartSource from './SourcePiechart';
import styles from './company.module.scss';
import { CompanyDashboardProps } from './constants';
import { SourceCO2eResponse } from 'models/MainDashboard/emissionModelSource.model';
import { EmissionResponse } from 'models/MainDashboard/emissionModel.model';

interface ScopeDropdownAndPieChartProps {
  scopeValue: string;
  handleChangeScope: (val: string) => void;
  scopeData: { label: string; value: string }[];
  pieloading: boolean;
  firstYear: string;
  parentID: number;
  locationOption: string;
  isScopeEmission: boolean;
  fetchEmissionData: (params: {
    year?: number;
    organizationId?: number;
    locationId?: number;
    exportType?: string;
  }) => Promise<void>;
  fetchEmissionDataSource: (params: {
    year?: number;
    organizationId?: number;
    scopeCategory?: string;
    locationId?: number;
    exportType?: string;
  }) => Promise<void>;
  emissionSourceChartData: SourceCO2eResponse | undefined;
  emissionScopeChartData: EmissionResponse | undefined;
}

const ScopeDropdownAndPieChart: React.FC<ScopeDropdownAndPieChartProps> = ({
  scopeValue,
  handleChangeScope,
  scopeData,
  pieloading,
  firstYear,
  parentID,
  locationOption,
  isScopeEmission,
  fetchEmissionData,
  fetchEmissionDataSource,
  emissionSourceChartData,
  emissionScopeChartData,
}) => {
  return (
    <div className={styles.yoyEmissionArea}>
      <div className={styles.scopeDropdownArea}>
        <Row align="bottom" justify="space-between">
          <Col span={16}>
            <h5 className={clsx(styles.yoyEmissionTitle, styles.extraMargin)}>
              {CompanyDashboardProps.SCOPE_TEXT}
            </h5>
          </Col>
          <Col className={styles.extraMargin} span={8}>
            <Dropdown
              placeholder={CompanyDashboardProps.SELECT_TEXT}
              value={scopeValue}
              onChange={handleChangeScope}
              options={scopeData}
            />
          </Col>
        </Row>
      </div>
      <div className={clsx(styles.cardContainer, styles.cardChartLongHeight)}>
        {pieloading ? (
          <div className={styles.loaderContainer}>
            <LoaderAnimation />
          </div>
        ) : (
          <PieChartSource
            year={Number(firstYear)}
            orgId={Number(parentID)}
            locationId={locationOption}
            scopeCategory={scopeValue}
            fetchEmissionDataSource={
              isScopeEmission ? fetchEmissionData : fetchEmissionDataSource
            }
            sourceData={emissionSourceChartData}
            scopeData={emissionScopeChartData}
            loading={pieloading}
          />
        )}
      </div>
    </div>
  );
};

export default ScopeDropdownAndPieChart;
